/**
 * Telling game scripts apart from other source files by their text, as the
 * dev server and the browser version list them for the editor.
 */

const IMPORTED = /import\s*\{([^}]*)\}\s*from\s*['"]@animo-editor\/[^'"]+['"]/g;
const DEFAULT_CLASS = /export\s+default\s+class\b[^{]*?\bextends\s+([A-Za-z_$][\w$]*)/;

/**
 * True for source text that defines a script: one that extends `Script` from
 * the runtime, or whose default export extends a script a kit ships, such as
 * `export default class extends Ladder {}` with `Ladder` imported from
 * `@animo-editor/kit-platformer`.
 */
export function isScriptSource(code: string): boolean {
  if (code.includes('@animo-editor/runtime') && /\bextends\s+Script\b/.test(code)) return true;
  const base = DEFAULT_CLASS.exec(code)?.[1];
  if (!base) return false;
  for (const m of code.matchAll(IMPORTED)) {
    for (const part of m[1]!.split(',')) {
      const name = part.replace(/^\s*type\s+/, '').trim().split(/\s+as\s+/).pop()?.trim();
      if (name === base) return true;
    }
  }
  return false;
}

/** Where objects attach a script a plugin ships: `animo.platformer/Player`. */
export function pluginScriptPath(pluginId: string, name: string): string {
  return `${pluginId}/${name}`;
}

/**
 * True for a script a plugin ships rather than a file in the game: a dotted
 * plugin id, a slash and a name, with no file extension.
 */
export function isPluginScript(path: string): boolean {
  return /^[a-z][\w-]*(\.[\w-]+)+\/[A-Za-z_$][\w$]*$/.test(path);
}
